var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaestraSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 190 241",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3643,
    cy: 78.9918,
    rx: 40.8575,
    ry: 67.6775,
    transform: "rotate(-33.3989 71.3643 78.9918)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.912,
    cy: 88.6295,
    rx: 21.4308,
    ry: 40.7788,
    transform: "rotate(-3.09375 153.912 88.6295)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.8635,
    cy: 184.546,
    rx: 42.6943,
    ry: 33.2428,
    transform: "rotate(1.70952 61.8635 184.546)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.518,
    cy: 162.487,
    rx: 18.4762,
    ry: 23.8181,
    transform: "rotate(13.2633 134.518 162.487)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.611,
    cy: 216.654,
    rx: 14.2463,
    ry: 20.7794,
    transform: "rotate(49.3499 119.611 216.654)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.439,
    cy: 194.317,
    rx: 8.51156,
    ry: 16.1969,
    transform: "rotate(29.9427 158.439 194.317)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.382,
    cy: 149.137,
    rx: 10.8196,
    ry: 19.9438,
    transform: "rotate(13.3397 174.382 149.137)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestraSymbol);
export default __webpack_public_path__ + "static/media/maestra-symbol.9d6ad4ac12e5f723c003c39c741fee7f.svg";
export { ForwardRef as ReactComponent };